const navbarList = document.querySelectorAll('.ja_bs_navbar');

function initHamburgerMenuBtn(navbar, collapseEl) {
  collapseEl.addEventListener('show.bs.collapse', function () {
    navbar.querySelector('.navbar-toggler .hamburger').classList.add('is-active');
  });
  collapseEl.addEventListener('hide.bs.collapse', function () {
    navbar.querySelector('.navbar-toggler .hamburger').classList.remove('is-active');
  });
}


if (navbarList.length) {
  for (let i = 0; i < navbarList.length; i++) {
    const navbar = navbarList[i];
    const collapseEl = navbar.querySelector('.collapse');

    const bsCollapse = new bootstrap.Collapse(collapseEl, {
      toggle: false
    });


    initHamburgerMenuBtn(navbar, collapseEl);

  }
}



